import './ActiveNoodle.css';
import React from "react";
import lightbulb from '../assets/images/lightbulb.svg';

function Tip(props) {
  return (
      <div className="tipSection">
          <img className="lightbulbImage" src={lightbulb} alt="blinking lightbulb" />
          <p className="tipText"> {props.tip} </p>
    </div>
  );
}

export default Tip;